<template>
  <div>
    <b-card>
      <div class="d-flex flex-wrap">
        <h4>Список направлений</h4>
        <b-button
          variant="primary"
          @click="onAddDirection"
          class="d-block ml-auto"
        >
          Добавить
        </b-button>
      </div>
      <div class="ag-grid-olympics-list mt-2" ref="gridDiv">
        <ag-grid-vue
          class="ag-theme-material h-100"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :rowData="rowData"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
        >
        </ag-grid-vue>
      </div>
    </b-card>
    <DeleteModal
      id="deleteDirectionModal"
      title="Подтверждение удаления направления"
      @delete="onDeleteConfirm"
    >
      {{ deleteText }}
    </DeleteModal>
    <EditDirectionModal :editData="selected" @save="onSaveDirection" />
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { clientWidthType } from '@/config/config'
import AgGridFactory from '@/components/helpers/factory/agGrid'
import DeleteModal from '@/components/ui/modals/DeleteModal.vue'
import EditDirectionModal from '@/components/admin/modals/recommendations/EditDirectionModal.vue'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'DirectionGroups',
  components: {
    AgGridVue,
    DeleteModal,
    EditDirectionModal
  },
  data() {
    return {
      gridOptions: AgGridFactory.getGridOptionsDefault(),
      columnDefs: [
        {
          headerName: 'Классификатор',
          field: 'group.code',
          suppressSizeToFit: true,
          width: 100
        },
        {
          headerName: 'Код',
          field: 'code',
          suppressSizeToFit: true,
          width: 120
        },
        {
          headerName: 'Название',
          field: 'title',
          minWidth: 100,
          width: 350
        },
        AgGridFactory.getDefaultActionRenderer({
          onEdit: this.onEditClick,
          onDelete: this.onDeleteClick
        })
      ],
      rowData: [],
      gridApi: null,
      deleteText: 'При удалении направлений будут также '
        + 'удалены соответствующие направления у вузов-партнеров и связанная с ними информация. '
        + 'Вы подтверждаете удаление?',
      selected: null
    }
  },
  async created() {
    await this.updateDirections()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.onGridSizeChanged()
      params.api.resetRowHeights()
    },
    onGridSizeChanged() {
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.TIGHT) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    async updateDirections() {
      const response = await RecommendationAPI.getAllDirections()
      const directions = []
      for (const group of response.data) {
        directions.push(...group.educationDirections
          .map((dir) => ({ ...dir, group })))
      }
      const filterModel = this.gridOptions.api ? this.gridOptions.api.getFilterModel() : null
      const sortModel = this.gridOptions.api ? this.gridOptions.api.getSortModel() : null
      this.rowData = directions
      this.$nextTick(() => {
        if (this.gridOptions.api) {
          this.gridOptions.api.setFilterModel(filterModel)
          this.gridOptions.api.setSortModel(sortModel)
        }
      })
    },
    onEditClick(params) {
      this.selected = params
      this.$bvModal.show('editDirectionModal')
    },
    onDeleteClick(params) {
      this.selected = params
      this.$bvModal.show('deleteDirectionModal')
    },
    onAddDirection() {
      this.selected = null
      this.$bvModal.show('editDirectionModal')
    },
    async onDeleteConfirm() {
      await RecommendationAPI.deleteDirection(this.selected.id)
      await this.updateDirections()
    },
    async onSaveDirection(params) {
      const data = {
        ...params,
        groupId: params.group[0].id
      }
      if (params.id) {
        await RecommendationAPI.updateDirection(data)
      } else {
        await RecommendationAPI.addDirection(data)
      }
      await this.updateDirections()
    }
  }
}
</script>

<style scoped>
.ag-grid-olympics-list {
  height: calc(100vh - 230px);
}
</style>
